var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-item"},[_vm._t("default"),(_vm.showSperate)?_c('div',{staticClass:"sperate-line"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }